const draftstarsTheme = require('./draftstarsTheme');

module.exports = {
  build: {
    files: {
      imageDir: 'india'
    },
    meta: {
      title: 'Draftstars',
      url: 'https://www.draftstars.in/lobby',
      maskIcon: {
        color: '#ff114f',
        href: '/safari-pinned-tab.svg'
      }
    },
    scripts: [
      {
        src: 'https://secure.ewaypayments.com/scripts/eCrypt.js'
      },
      {
        src: 'https://www.googletagservices.com/tag/js/gpt.js',
        async: true
      }
    ]
  },
  app: {
    default: {
      settings: {
        ads: false,
        availableBonuses: [],
        appLinks: [
          {
            type: 'android',
            imageUri: '/images/android-download.png',
            href: 'https://www.draftstars.in/android'
          }
        ],
        razorpayKeyStaging: 'rzp_test_Jsu2ZeWxRaduJ5',
        razorpayKey: 'rzp_live_MXZ1gVJOLndGNJ',
        razorpayMerchantName: 'Fantasy Studio India Pvt Limited',
        chatURI: 'https://chat.sportsfantasyhq.com/',
        challengeCategories: ['all', 'featured', 'paid', 'free', 'h2h'],
        hideAddressSuggest: true,
        content: {
          howToPlay: {
            bannerDesktop: '/images/howtoplay/desktop/banner.jpg',
            bannerMobile: '/images/howtoplay/mobile/banner.jpg',
            pages: [
              {
                title: 'Meet Draftstars',
                description:
                  'Draftstars adds a whole new dimension to the excitement of live sport. We do this through our exhilarating daily fantasy sports site which is now available to play in India. Best of all, by entering a contest you can compete for the huge cash prizes on offer every day. Playing Draftstars is simple. Here are three steps to get you started.'
              },
              {
                title: 'Step 1: Choose your\u00A0contest',
                description:
                  'Are you ready to play your favourite fantasy sports and win prizes at the same time? Go to the lobby, filter by sport and choose your contest!',
                desktopImages: [
                  '/images/howtoplay/desktop/step1.jpg',
                  '/images/howtoplay/desktop/step1@2x.jpg'
                ],
                mobileImages: [
                  '/images/howtoplay/mobile/step1.jpg',
                  '/images/howtoplay/mobile/step1@2x.jpg'
                ],
                frame: true
              },
              {
                title: 'Step 2: Select your\u00A0players',
                description:
                  "Create your lineup of players while staying within the salary cap. Which players are in good form? Who is due for a big game? What's your selection strategy?",
                desktopImages: [
                  '/images/howtoplay/desktop/step2.jpg',
                  '/images/howtoplay/desktop/step2@2x.jpg'
                ],
                mobileImages: [
                  '/images/howtoplay/mobile/step2.jpg',
                  '/images/howtoplay/mobile/step2@2x.jpg'
                ],
                frame: true
              },
              {
                title: 'Step 3 - Watch and Win!',
                description:
                  'This is where the excitement really starts! Your players accrue points based on their real life performance. Make sure you keep an eye on the live leaderboard as you climb to number&nbsp;one!',
                desktopImages: [
                  '/images/howtoplay/desktop/step3.jpg',
                  '/images/howtoplay/desktop/step3@2x.jpg'
                ],
                mobileImages: [
                  '/images/howtoplay/mobile/step3.png',
                  '/images/howtoplay/mobile/step3@2x.png'
                ],
                frame: true
              }
            ]
          }
        },
        copyright: '© 2019 Fantasy Studio Pvt Ltd. All Rights Reserved.',
        darkMode: false,
        depositBanner: {
          image: '/images/carousel-mobile/deposit_bonus.jpg',
          title: 'Get a deposit bonus - equivalent to the amount of your 1st depost.'
        },
        displayGamblingHelp: false,
        displayGlobalLeaderboard: false,
        displayLoadLineup: true,
        displayLobbyBanner: true,
        displayNotificationModal: true,
        displayTop8: true,
        displayUserQuestions: false,
        displayMyTeams: true,
        displayTraining: false,
        displayVerificationLink: true,
        displayJackpotSlots: false,
        displayRapidFire: false,
        displayCreateH2H: false,
        enableAccountLimit: false,
        enableUploadLineup: false,
        feedbackUri: null,
        hasH2H: true,
        hasLightBackground: true,
        hasNightMode: true,
        multiEntry: true,
        mustVerifyPhoneToEnterPaidChallenge: false,
        notification: {
          title: 'DRAFTSTARS INDIA WILL BE TAKING A TEMPORARY BREAK',
          content:
            'This means there will be no more contests to play until our relaunch. You can still login to your account as normal. If you need assistance please contact us at support@draftstars.in\nThank you for your support and we will see you soon!'
        },
        filters: {
          theme: 'light',
          complexity: true,
          entrants: true,
          fee: true,
          payout: true,
          size: false,
          entrantsOptions: [2, 6, 10, 20, 50, 100, 500, null],
          feeOptions: [0, 1, 2, 5, 10, 15, 20, 50, 200, 500]
        },
        hasMultiplierPayout: true,
        locale: 'au-draftstars',
        logoImage: '/images/logo-header-new.png',
        mobileHeaderImage: '/images/logo-header-new.png',
        onesport: false,
        onesportPlatform: 2,
        promo: [
          {
            link: '/how-to-play',
            desktopSrc: '/images/carousel-desktop/starter_guide.png',
            mobileSrc: '/images/carousel-mobile/starter_guide.png'
          },
          {
            link: '/lobby?modal=signin',
            linkSignedIn: '/lobby?modal=deposit',
            desktopSrc: '/images/carousel-desktop/deposit_bonus.jpg',
            mobileSrc: '/images/carousel-mobile/deposit_bonus.jpg'
          }
        ],
        rewriteRules: {
          '/challenge': '/contest',
          '/enter-additional-challenges': '/enter-additional-contests',
          '/live-challenges': '/live-contests',
          '/my-challenges': '/my-contests',
          '/rapidfire/challenge': '/rapidfire/contest',
          '/training/challenge': '/training/contest'
        },
        secondaryLinks: [
          {
            title: 'About',
            items: [
              {
                type: 'route',
                href: '/about',
                name: 'About',
                category: 'more',
                icon: 'icon_menu_about'
              }
            ]
          },
          {
            title: 'Help',
            items: [
              {
                type: 'route',
                href: '/contact-us',
                name: 'Contact Us',
                category: 'more',
                icon: 'icon_menu_contact'
              },
              {
                type: 'route',
                href: '/how-to-play',
                name: 'How to Play',
                category: 'more',
                icon: 'icon_menu_how_to_play'
              },
              // {
              //   type: 'route',
              //   href: '/rules',
              //   name: 'Rules',
              //   category: 'more',
              //   icon: 'icon_menu_rules',
              // },
              {
                type: 'route',
                href: '/faqs',
                name: 'FAQs',
                category: 'more',
                icon: 'icon_menu_faqs'
              }
            ]
          },
          {
            title: 'More',
            items: [
              {
                type: 'route',
                href: '/terms',
                name: 'Terms & Conditions',
                category: 'more',
                icon: 'icon_menu_terms_conditions'
              },
              {
                type: 'route',
                href: '/privacy-policy',
                name: 'Privacy Policy',
                category: 'more',
                icon: 'icon_menu_privacy_policy'
              }
            ]
          }
        ],
        siteName: 'Draftstars',
        social: {
          messages: {
            enteredAndOpen: "I've entered this contest, come join me!",
            enteredAndInProgress:
              "If you're not first, you're last! Check out the Live Leaderboard!",
            enteredAndCompleted:
              'Run and won. What a game! Check out the Leaderboard to see who cashed in!',
            notEntered: 'No excuses, play like a champion!'
          }
          // twitterUrl: 'https://twitter.com/DraftstarsAU',
          // facebookUrl: 'https://www.facebook.com/draftstarsau/',
          // twitterVia: 'DraftstarsAU',
        },
        stateFieldType: 'select',
        paymentMethods: [
          {
            label: 'Razorpay',
            value: 'razorpay'
          }
        ],
        defaultPaymentMethod: 'razorpay'
      },
      theme: draftstarsTheme.theme,
      skin: draftstarsTheme.skin
    },
    development: {
      settings: {
        onesportSource: 'https://client-api.onesport.org',
        dataSource: 'https://draftstars-in-api.sportsfantasyhq.com',
        verificationUri: 'https://draftstars-in-content.sportsfantasyhq.com/verification',
        siteUrl: 'https://draftstars-in.sportsfantasyhq.com'
      }
    },
    staging: {
      chatURI: 'https://chat.sportsfantasyhq.com',
      settings: {
        onesportSource: 'https://client-api.onesport.org',
        dataSource: 'https://draftstars-in-api.sportsfantasyhq.com',
        verificationUri: 'https://draftstars-in-content.sportsfantasyhq.com/verification',
        siteUrl: 'https://draftstars-in.sportsfantasyhq.com'
      }
    },
    uat: {
      settings: {
        chatURI: 'https://chat.sportsfantasyhq.com',
        onesportSource: 'https://push-v2.onesport.org',
        dataSource: 'https://draftstars-in-api.sportsfantasyhq.com',
        verificationUri: 'https://draftstars-in-content.sportsfantasyhq.com/verification',
        siteUrl: 'https://draftstars-in.sportsfantasyhq.com'
      }
    },
    production: {
      settings: {
        chatURI: 'https://chat.draftstars.in',
        onesportSource: 'https://client-api.onesport.org',
        dataSource: 'https://api.draftstars.in',
        googleTagManagerId: 'GTM-MVMNRHJ',
        verificationUri: 'https://content.draftstars.in/verification',
        siteUrl: 'https://play.draftstars.in'
      }
    }
  }
};
